<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="configAuto" :queryHandler="queryHandler" :popupHandler="popupHandler"></swb-query-sort-area>
        </div>

        <div class="simple-row" v-if="checkActionPerm('create')">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="saveDataDlg(true)">
                    <span>添加消息订阅模版</span>
                </button>
            </div>
        </div>

        <swb-result-table name="result_table" ref="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" :confKey="confKey" :configAuto="configAuto" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $} from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes  } from '../../app.vues'

    import { checkUserActionPerm } from '../index'
    import { getDefaultPageSizes } from '../../app.conf'

    import userApi from '../../api/user';
    import bizMsgApi from '../../api/bizMsg'

    import SwbBizEventMsgSubscrTplSave from './BizEventMsgSubscrTplSave';
    Vue.regist(SwbBizEventMsgSubscrTplSave);

    import SwbBizEventMsgTplSubscrSave from './BizEventMsgTplSubscrSave';
    Vue.regist(SwbBizEventMsgTplSubscrSave);

    import SwbBizEventMsgSubscrTplSetStaff from './BizEventMsgSubscrTplSetStaff';
    Vue.regist(SwbBizEventMsgSubscrTplSetStaff);

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';
    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    export default {
        name: 'swb-biz-event-msg-subscr-tpl-list',
        path: '/biz/event/msg/subscr/tpl/list',
        desc: '消息订阅模版管理',
        helpArticleCode: 'servicer-biz-event-msg-subscr-tpl-list',
        data: function () {
            return {
                confKey: 'swb-biz-event-msg-subscr-tpl-list',
                configAuto: true,
                tableHeight: '300',
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                // 过滤信息
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                // 其他信息
                dataList: []
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            //
            this.getDataList();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass("overflow-hidden");
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            console.log("domHeight： " + self.domHeight);
            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"], .simple-row'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                // let confColList = resultColConfCmp.getMetaColList();
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);    // .getResultColConfRef()
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'shopFlag': function (row, colName, colValue, rowIndex) {
                        let shopFlag = row.shopFlag ? "是" : "否";

                        return '<span>' + shopFlag + '</span>';
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];

                        if(self.checkActionPerm('modify')) {
                            btnList.push({
                                name: 'modify',
                                text: '修改'
                            });
                        }
                        if(self.checkActionPerm('delete')) {
                            btnList.push({
                                name: 'delete',
                                text: '删除'
                            });
                        }
                        if(self.checkActionPerm('set_subscr')) {
                            btnList.push({
                                name: 'set_subscr',
                                text: '订阅设置'
                            });
                        }
                        if(self.checkActionPerm('set_staff')) {
                            btnList.push({
                                name: 'set_staff',
                                text: '员工订阅'
                            });
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName === 'modify') {
                            self.saveDataDlg(false, row);
                        } else if(btnName === 'delete') {
                            self.deleteData(row.id);
                        } else if(btnName === 'set_subscr') {
                            self.saveTplSubscr(row);
                        } else if(btnName === 'set_staff') {
                            self.showStaffDlg(row);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            popupHandler: function (fieldCode, curValue, curText) {
            },
            //
            checkActionPerm: function (action) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, null);
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getDataList();
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDataList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDataList();
            },
            getDataList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                // 调用查询接口
                bizMsgApi.getBizEventMsgSubscrTplList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        let dataList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.renderTable(dataList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            saveDataDlg(isAdd, row){
                isAdd = Utils.isTrue(isAdd);
                let title = isAdd ? "添加消息订阅模版" : "更新消息订阅模版";
                let roleInfo = Utils.merge({}, row);
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: title,
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-biz-event-msg-subscr-tpl-save :item="roleInfo" ref="swb_tpl_save"></swb-biz-event-msg-subscr-tpl-save>' +
                    '</div>',
                    data: {
                        roleInfo: roleInfo
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_tpl_save.getDlgResult() || {};
                        if(result.type == 'info') {
                            // 处理你的信息添加赋值
                            let tplComRole = result.data;
                            if(isAdd) {
                                let theLoading = MsgBox.loading();
                                bizMsgApi.saveBizEventMsgSubscrTpl(tplComRole, function (result) {
                                    theLoading.close();
                                    if(result.type == 'info') {
                                        theDlg.close();
                                        self.$message.success("操作成功");
                                        self.getDataList();
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            } else {
                                let theLoading = MsgBox.loading();
                                bizMsgApi.updateBizEventMsgSubscrTpl(tplComRole, function (result) {
                                    theLoading.close();
                                    if(result.type == 'info') {
                                        theDlg.close();
                                        self.$message.success("操作成功");
                                        self.getDataList();
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            }
                        }
                        return false;
                    }
                });
            },
            deleteData(id){
                //弹出确认框
                let self = this;
                this.$confirm('确认删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoading = MsgBox.loading();
                    bizMsgApi.deleteBizEventMsgSubscrTpl(id, function (result) {
                        theLoading.close();
                        if(result.type == 'info') {
                            self.$message.success("操作成功");
                            self.getDataList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            saveTplSubscr(row){
                let theDlg = Vue.$showDialog({
                    title: "消息模版订阅保存",
                    showCloseBtn: true,
                    width: '90%',
                    height: '90%',
                    template: '<div>' +
                    '<swb-biz-event-msg-tpl-subscr-save :tplId="tplId" :shopFlag="shopFlag" ref="swb_tpl_subscr_save"></swb-biz-event-msg-tpl-subscr-save>' +
                    '</div>',
                    data: {
                        tplId: row.id,
                        shopFlag: row.shopFlag
                    },
                    okClicked: function () {
                        let bizEventMsgSubscrDto = this.$refs.swb_tpl_subscr_save.getDlgResult();
                        if(!Utils.isNoB(bizEventMsgSubscrDto)) {
                            let theLoading = MsgBox.loading();
                            bizMsgApi.saveBizEventMsgTplSubscr(bizEventMsgSubscrDto, function (result) {
                                theLoading.close();
                                if(result.type === "info") {
                                    theDlg.close();
                                    MsgBox.success("操作成功！");
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        }
                        return false;
                    }
                });
            },
            showStaffDlg(row){
                let theDlg = Vue.$showDialog({
                    title: "员工订阅",
                    showCloseBtn: true,
                    width: '90%',
                    height: '90%',
                    okVisible: false,
                    cancelText: '关闭',
                    template: '<div>' +
                    '<swb-biz-event-msg-subscr-tpl-set-staff :shopFlag="shopFlag" :tplId="tplId" ref="swb_tpl_set_staff"></swb-biz-event-msg-subscr-tpl-set-staff>' +
                    '</div>',
                    data: {
                        tplId: row.id,
                        shopFlag: row.shopFlag
                    },
                    okClicked: function () {
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizMsg/BizEventMsgSubscrTplList.vue